/* MATLEON — Garabatos a mano que se dibujan solos.
   Cada garabato es un <span class="mt-garabato" data-g="tipo"> vacío que deja el tema; mt-styles.css le da tamaño y lugar.
   Este archivo lo llena con una PINCELADA de verdad (no una línea): delgada al empezar, gruesa a la mitad y afilada al
   levantar el plumón, con un temblor leve de mano. Se calcula al tamaño real del lugar en cada pantalla (px), así se ve
   igual en iPhone (Safari) y Android, sin estirar nada.
   Para "dibujarla", una máscara recorre el centro de la pincelada (stroke-dashoffset en px, animado con WAAPI).
   Cuándo se dibuja:
   - Portada: al cargar, después de que el título llega a su lugar; luego se escribe la nota y al final sale la flecha.
   - Lo demás: cuando su sección entra en pantalla (mt-scripts.js le pone la clase mt-visible).
   Con "reducir movimiento" o en el editor de Shopify se ven completos (en el editor sin animar). */
(function () {
  'use strict';
  if (!window.SVGElement || !document.querySelector) return;

  var NS = 'http://www.w3.org/2000/svg';
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)');
  var editor = document.documentElement.classList.contains('shopify-design-mode') || (window.Shopify && window.Shopify.designMode);
  // Velocidad de mano: arranca, avanza y frena (easeInOutCubic). La nota se escribe a ritmo parejo (easeInOutSine).
  var CURVA_TRAZO = 'cubic-bezier(0.65, 0, 0.35, 1)';
  var CURVA_LETRA = 'cubic-bezier(0.37, 0, 0.63, 1)';
  var PAUSA = 70;   // ms que "se levanta el plumón" entre trazos
  var contador = 0;

  /* ---------- utilidades de geometría ---------- */
  function bezier(p0, p1, p2, p3, n) {
    var out = [];
    for (var i = 0; i <= n; i++) {
      var t = i / n, u = 1 - t;
      out.push([
        u * u * u * p0[0] + 3 * u * u * t * p1[0] + 3 * u * t * t * p2[0] + t * t * t * p3[0],
        u * u * u * p0[1] + 3 * u * u * t * p1[1] + 3 * u * t * t * p2[1] + t * t * t * p3[1]
      ]);
    }
    return out;
  }
  function unir(a, b) { return a.concat(b.slice(1)); }
  // Línea quebrada con esquinas apenas redondeadas (Chaikin), y puntos repartidos para que la pincelada sea pareja
  function quebrada(pts, cortes) {
    var p = pts;
    for (var k = 0; k < 2; k++) {
      var q = [p[0]];
      for (var i = 0; i < p.length - 1; i++) {
        var a = p[i], b = p[i + 1], r = cortes || 0.18;
        q.push([a[0] + (b[0] - a[0]) * r, a[1] + (b[1] - a[1]) * r]);
        q.push([a[0] + (b[0] - a[0]) * (1 - r), a[1] + (b[1] - a[1]) * (1 - r)]);
      }
      q.push(p[p.length - 1]);
      p = q;
    }
    return repartir(p, 4);
  }
  function largo(pts) {
    var L = 0;
    for (var i = 1; i < pts.length; i++) L += Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]);
    return L;
  }
  // Reparte puntos cada ~paso px a lo largo del trazo
  function repartir(pts, paso) {
    var L = largo(pts), n = Math.max(8, Math.round(L / paso)), out = [pts[0]], seg = 0, acum = 0;
    var objetivo = L / n;
    for (var k = 1; k < n; k++) {
      var meta = k * objetivo;
      while (seg < pts.length - 1) {
        var d = Math.hypot(pts[seg + 1][0] - pts[seg][0], pts[seg + 1][1] - pts[seg][1]);
        if (acum + d >= meta) {
          var f = d ? (meta - acum) / d : 0;
          out.push([pts[seg][0] + (pts[seg + 1][0] - pts[seg][0]) * f, pts[seg][1] + (pts[seg + 1][1] - pts[seg][1]) * f]);
          break;
        }
        acum += d; seg++;
      }
    }
    out.push(pts[pts.length - 1]);
    return out;
  }
  // Números "al azar" pero siempre iguales para el mismo garabato (no cambian al recargar ni al girar el celular)
  function azar(semilla) {
    var s = semilla % 2147483647; if (s <= 0) s += 2147483646;
    return function () { s = s * 16807 % 2147483647; return (s - 1) / 2147483646; };
  }

  /* ---------- la pincelada ----------
     A partir del centro del trazo arma un contorno relleno: el ancho sigue la presión de una mano
     (entra rápido, se sostiene, se afila más lento al levantar) y el centro tiembla apenas. */
  function pincelada(centro, ancho, rnd, opciones) {
    opciones = opciones || {};
    var entrada = opciones.entrada || 0.1, salida = opciones.salida || 0.32;
    var n = centro.length, izq = [], der = [], linea = [];
    var f1 = 1 + rnd() * 1.5, f2 = 3 + rnd() * 2, a1 = rnd() * 6.28, a2 = rnd() * 6.28;
    var tiembla = ancho * (opciones.temblor == null ? 0.22 : opciones.temblor);
    for (var i = 0; i < n; i++) {
      var t = i / (n - 1);
      var a = centro[Math.max(0, i - 1)], b = centro[Math.min(n - 1, i + 1)];
      var dx = b[0] - a[0], dy = b[1] - a[1], l = Math.hypot(dx, dy) || 1;
      var nx = -dy / l, ny = dx / l;
      var w = Math.sin(t * Math.PI * f1 + a1) * 0.6 + Math.sin(t * Math.PI * f2 + a2) * 0.4;
      var x = centro[i][0] + nx * w * tiembla, y = centro[i][1] + ny * w * tiembla;
      var presion = Math.pow(Math.min(1, t / entrada), 0.55) * Math.pow(Math.min(1, (1 - t) / salida), 0.85);
      // Presión de la mano: más contraste entre lo delgado y lo grueso, y un pulso leve a lo largo del trazo
      var grosor = ancho * (0.16 + 0.84 * presion) * (0.86 + 0.26 * (0.5 + 0.5 * Math.sin(t * 7.5 + a2))) / 2;
      izq.push([x + nx * grosor, y + ny * grosor]);
      der.push([x - nx * grosor, y - ny * grosor]);
      linea.push([x, y]);
    }
    var r0 = ancho * 0.11, r1 = ancho * 0.11;
    var d = 'M' + f(izq[0]);
    for (var j = 1; j < n; j++) d += 'L' + f(izq[j]);
    d += 'A' + r1.toFixed(2) + ' ' + r1.toFixed(2) + ' 0 0 1 ' + f(der[n - 1]);
    for (var k = n - 2; k >= 0; k--) d += 'L' + f(der[k]);
    d += 'A' + r0.toFixed(2) + ' ' + r0.toFixed(2) + ' 0 0 1 ' + f(izq[0]) + 'Z';
    return { contorno: d, linea: linea, ancho: ancho };
  }
  function f(p) { return p[0].toFixed(2) + ' ' + p[1].toFixed(2); }

  /* ---------- cada tipo de garabato (en px, dentro de su caja w × h) ----------
     Devuelve una lista de trazos en el orden en que una mano los haría. */
  var TIPOS = {
    subrayado: function (w, h, W) {
      return [
        { pts: bezier([w * 0.01, h * 0.66], [w * 0.3, h * 0.3], [w * 0.68, h * 0.26], [w * 0.99, h * 0.42], 40), ancho: W },
        { pts: bezier([w * 0.14, h * 0.98], [w * 0.4, h * 0.74], [w * 0.7, h * 0.7], [w * 0.92, h * 0.76], 30), ancho: W * 0.55, salida: 0.45 }
      ];
    },
    circulo: function (w, h, W, rnd) {
      // Un solo trazo que empieza arriba a la derecha, da la vuelta y se pasa del inicio (como una mano rápida)
      // Nada de óvalo perfecto: va inclinado, un poco abollado y al cerrar se mete hacia adentro
      var pts = [], cx = w * 0.5, cy = h * 0.53, giro = -0.075;
      var inicio = -1.05, fin = inicio - Math.PI * 2 - 0.7, n = 140;
      var b1 = rnd() * 6.28, b2 = rnd() * 6.28;
      for (var i = 0; i <= n; i++) {
        var s = i / n, th = inicio + (fin - inicio) * s;
        var abollado = 1 + 0.035 * Math.sin(2 * th + b1) + 0.02 * Math.sin(3 * th + b2);
        var rx = w * 0.485 * (1.02 - 0.08 * s) * abollado, ry = h * 0.47 * (1.04 - 0.16 * s) * abollado;
        var x = rx * Math.cos(th), y = ry * Math.sin(th);
        pts.push([cx + x * Math.cos(giro) - y * Math.sin(giro) + w * 0.02 * s, cy + x * Math.sin(giro) + y * Math.cos(giro) - h * 0.05 * s]);
      }
      return [{ pts: repartir(pts, 4), ancho: W, entrada: 0.04, salida: 0.18 }];
    },
    destello: function (w, h, W) {
      var o = [w * 0.04, h * 0.96], rayos = [[-96, 0.42, 1.0], [-48, 0.38, 1.02], [-6, 0.4, 0.98]], out = [];
      rayos.forEach(function (r) {
        var a = r[0] * Math.PI / 180, R = Math.min(w, h);
        var p0 = [o[0] + Math.cos(a) * R * r[1], o[1] + Math.sin(a) * R * r[1]];
        var p1 = [o[0] + Math.cos(a) * R * r[2], o[1] + Math.sin(a) * R * r[2]];
        out.push({ pts: bezier(p0, p0, p1, p1, 14), ancho: W, entrada: 0.2, salida: 0.55, temblor: 0.05 });
      });
      return out;
    },
    corona: function (w, h, W) {
      var P = function (x, y) { return [w * x, h * y]; };
      return [
        { pts: quebrada([P(0.1, 0.78), P(0.14, 0.18), P(0.35, 0.56), P(0.5, 0.06), P(0.66, 0.54), P(0.86, 0.16), P(0.9, 0.8)], 0.12), ancho: W, entrada: 0.05, salida: 0.15, temblor: 0.1 },
        { pts: bezier(P(0.07, 0.95), P(0.35, 0.9), P(0.65, 0.9), P(0.94, 0.94), 20), ancho: W * 0.7, salida: 0.4 }
      ];
    },
    flecha: function (w, h, W) {
      var P = function (x, y) { return [w * x / 80, h * y / 80]; };
      return [
        { pts: bezier(P(10, 6), P(14, 34), P(34, 58), P(68, 66), 40), ancho: W },
        { pts: quebrada([P(52, 54), P(69, 66), P(51, 75)], 0.08), ancho: W * 0.9, entrada: 0.12, salida: 0.3, temblor: 0.06 }
      ];
    },
    // Pie: flecha corta que regresa hacia @_matleon; la punta es grande para que se lea como flecha y no como sonrisa
    'flecha-izq': function (w, h, W) {
      var P = function (x, y) { return [w * x / 64, h * y / 38]; };
      return [
        { pts: bezier(P(60, 12), P(50, 30), P(28, 30), P(6, 21), 30), ancho: W, salida: 0.15 },
        { pts: quebrada([P(20, 7), P(6, 21), P(21, 33)], 0.06), ancho: W * 1.05, entrada: 0.1, salida: 0.25, temblor: 0.05 }
      ];
    },
    // Portada revista: ∞ junto a "Edición permanente". Un solo trazo que arranca en el cruce del centro, da las dos
    // vueltas y se pasa un poco del inicio (como mano rápida); se aplana hacia el final
    infinito: function (w, h, W) {
      var pts = [], n = 140, t0 = Math.PI / 2 - 0.12, t1 = Math.PI / 2 + Math.PI * 2 + 0.22;
      for (var i = 0; i <= n; i++) {
        var s = i / n, t = t0 + (t1 - t0) * s, sn = Math.sin(t), cs = Math.cos(t), d = 1 + sn * sn;
        pts.push([w * 0.5 + (cs / d) * w * 0.47 + s * w * 0.02, h * 0.5 + (sn * cs / d) * h * 1.25 * (1 - 0.12 * s) - s * h * 0.05]);
      }
      return [{ pts: repartir(pts, 2.5), ancho: W, entrada: 0.06, salida: 0.12, temblor: 0.08 }];
    },
    /* ---- Edición de temporada (portada): un dibujo por temporada, trazos en el orden en que una mano los haría ---- */
    // Otoño: contorno de la hoja (un trazo), la vena del centro y el tallito
    hoja: function (w, h, W) {
      var P = function (x, y) { return [w * x / 100, h * y / 100]; };
      return [
        { pts: unir(bezier(P(24, 78), P(6, 44), P(38, 8), P(86, 12), 30), bezier(P(86, 12), P(92, 52), P(62, 88), P(24, 78), 30)), ancho: W, entrada: 0.05, salida: 0.1 },
        { pts: bezier(P(24, 78), P(42, 58), P(60, 38), P(80, 18), 20), ancho: W * 0.75, salida: 0.4 },
        { pts: bezier(P(24, 78), P(20, 84), P(15, 90), P(8, 96), 10), ancho: W * 0.85, salida: 0.3, temblor: 0.05 }
      ];
    },
    // Invierno: tres rayas que se cruzan (seis brazos) y una "v" en la punta de cada brazo
    copo: function (w, h, W) {
      var cx = w / 2, cy = h / 2, R = Math.min(w, h) * 0.47, out = [];
      [90, 30, 150].forEach(function (g) {
        var a = g * Math.PI / 180, dx = Math.cos(a) * R, dy = Math.sin(a) * R;
        out.push({ pts: bezier([cx - dx, cy - dy], [cx - dx, cy - dy], [cx + dx, cy + dy], [cx + dx, cy + dy], 16), ancho: W, entrada: 0.15, salida: 0.15, temblor: 0.04 });
      });
      for (var k = 0; k < 6; k++) {
        var a = (90 + k * 60) * Math.PI / 180, px = cx + Math.cos(a) * R * 0.66, py = cy + Math.sin(a) * R * 0.66, L = R * 0.3;
        var izq = [px + Math.cos(a + 2.4) * L, py + Math.sin(a + 2.4) * L], der = [px + Math.cos(a - 2.4) * L, py + Math.sin(a - 2.4) * L];
        out.push({ pts: quebrada([izq, [px, py], der], 0.1), ancho: W * 0.8, entrada: 0.2, salida: 0.25, temblor: 0.03 });
      }
      return out;
    },
    // Primavera: el tallo crece desde abajo, salen dos hojitas y arriba el botón
    brote: function (w, h, W) {
      var P = function (x, y) { return [w * x / 100, h * y / 100]; };
      var boton = [], n = 40;
      for (var i = 0; i <= n; i++) { var t = -Math.PI / 2 + (Math.PI * 2 + 0.5) * i / n; boton.push(P(50 + Math.cos(t) * 13, 22 + Math.sin(t) * 13)); }
      return [
        { pts: bezier(P(50, 98), P(54, 76), P(44, 56), P(50, 36), 24), ancho: W, entrada: 0.08, salida: 0.12 },
        { pts: unir(bezier(P(49, 72), P(36, 70), P(20, 60), P(16, 48), 14), bezier(P(16, 48), P(30, 46), P(44, 54), P(49, 66), 14)), ancho: W * 0.85, entrada: 0.1, salida: 0.2 },
        { pts: unir(bezier(P(50, 58), P(62, 54), P(78, 46), P(84, 34), 14), bezier(P(84, 34), P(70, 34), P(56, 42), P(51, 52), 14)), ancho: W * 0.85, entrada: 0.1, salida: 0.2 },
        { pts: repartir(boton, 2), ancho: W * 0.9, entrada: 0.06, salida: 0.12 }
      ];
    },
    // Verano: el sol (un círculo que se pasa un poquito del inicio) y ocho rayos cortos
    sol: function (w, h, W) {
      var cx = w / 2, cy = h / 2, R = Math.min(w, h) / 2, circ = [], n = 60, out = [];
      for (var i = 0; i <= n; i++) { var t = -Math.PI / 2 + (Math.PI * 2 + 0.35) * i / n; circ.push([cx + Math.cos(t) * R * 0.44, cy + Math.sin(t) * R * 0.44]); }
      out.push({ pts: repartir(circ, 2), ancho: W, entrada: 0.05, salida: 0.12 });
      for (var k = 0; k < 8; k++) {
        var a = (k * 45 - 90) * Math.PI / 180;
        var p0 = [cx + Math.cos(a) * R * 0.66, cy + Math.sin(a) * R * 0.66], p1 = [cx + Math.cos(a) * R * 0.98, cy + Math.sin(a) * R * 0.98];
        out.push({ pts: bezier(p0, p0, p1, p1, 8), ancho: W * 0.85, entrada: 0.2, salida: 0.45, temblor: 0.03 });
      }
      return out;
    },
    // Portada revista: sale de junto a la notita (abajo a la derecha), barre hacia la izquierda y sube hasta el tenis
    'flecha-rv': function (w, h, W) {
      var P = function (x, y) { return [w * x / 100, h * y / 100]; };
      return [
        { pts: bezier(P(96, 94), P(58, 99), P(24, 84), P(16, 22), 40), ancho: W, salida: 0.18 },
        { pts: quebrada([P(3, 38), P(16, 21), P(31, 35)], 0.08), ancho: W * 0.95, entrada: 0.12, salida: 0.3, temblor: 0.06 }
      ];
    }
  };

  // Grosor del plumón según el tamaño de letra del lugar (en títulos grandes, trazo más grueso)
  function grosor(tipo, el) {
    var fs = parseFloat(getComputedStyle(el).fontSize) || 16;
    switch (tipo) {
      case 'subrayado': return Math.max(3, fs * 0.085);
      case 'circulo': return Math.max(3, fs * 0.07);
      case 'destello': return Math.max(2.6, fs * 0.07);
      case 'corona': return Math.max(2.4, fs * 0.065);
      case 'flecha-rv': return Math.max(3, Math.min(4.2, el.clientWidth * 0.045));
      case 'flecha-izq': return 2.8;
      case 'infinito': return Math.max(1.9, Math.min(2.6, el.clientWidth * 0.075));
      case 'hoja': case 'brote': case 'sol': case 'copo': return Math.max(1.7, Math.min(2.4, el.clientWidth * 0.095));
      default: return 3;
    }
  }

  function semillaDe(el, tipo) {
    var txt = tipo + (el.parentNode && el.parentNode.textContent || '');
    var s = 7;
    for (var i = 0; i < txt.length; i++) s = (s * 31 + txt.charCodeAt(i)) % 2147483647;
    return s;
  }

  /* ---------- armar el SVG dentro del span ---------- */
  function construir(el) {
    var tipo = el.getAttribute('data-g');
    var hacer = TIPOS[tipo];
    if (!hacer) return null;
    var w = el.clientWidth, h = el.clientHeight;
    if (w < 4 || h < 4) return null;
    var W = grosor(tipo, el), rnd = azar(semillaDe(el, tipo));
    var trazos = hacer(w, h, W, rnd);
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    svg.setAttribute('width', w); svg.setAttribute('height', h);
    svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
    var defs = document.createElementNS(NS, 'defs');
    svg.appendChild(defs);
    var lista = [];
    trazos.forEach(function (tr) {
      var p = pincelada(tr.pts, tr.ancho, rnd, tr);
      var id = 'mtg' + (++contador);
      var mask = document.createElementNS(NS, 'mask');
      mask.setAttribute('id', id);
      mask.setAttribute('maskUnits', 'userSpaceOnUse');
      mask.setAttribute('x', -40); mask.setAttribute('y', -40);
      mask.setAttribute('width', w + 80); mask.setAttribute('height', h + 80);
      var guia = document.createElementNS(NS, 'path');
      var dl = 'M' + p.linea.map(f).join('L');
      var L = largo(p.linea) + 2;
      guia.setAttribute('d', dl);
      guia.setAttribute('fill', 'none');
      guia.setAttribute('stroke', '#fff');
      guia.setAttribute('stroke-width', (tr.ancho * 2.4).toFixed(2));
      guia.setAttribute('stroke-linecap', 'round');
      guia.setAttribute('stroke-linejoin', 'round');
      guia.style.strokeDasharray = L + ' ' + (L + tr.ancho * 4);
      guia.style.strokeDashoffset = L + tr.ancho * 2;
      mask.appendChild(guia);
      defs.appendChild(mask);
      var tinta = document.createElementNS(NS, 'path');
      tinta.setAttribute('d', p.contorno);
      tinta.setAttribute('fill', 'currentColor');
      tinta.setAttribute('mask', 'url(#' + id + ')');
      svg.appendChild(tinta);
      lista.push({ guia: guia, L: L, oculto: L + tr.ancho * 2, ancho: tr.ancho });
    });
    el.textContent = '';
    el.appendChild(svg);
    el._mt = { trazos: lista, w: w, h: h };
    return el._mt;
  }

  // Cuánto tarda cada trazo: según lo largo, como una mano (los cortos son rápidos, los largos no se eternizan)
  function duracion(L) { return Math.round(Math.max(170, Math.min(820, 120 + L * 2.1))); }

  // Dibuja el garabato; devuelve cuánto tarda en total (ms)
  function dibujar(el, espera) {
    var g = el._mt || construir(el);
    if (!g) return 0;
    el._dibujado = true;
    if (reducido.matches || editor) {
      g.trazos.forEach(function (t) { t.guia.style.strokeDashoffset = 0; });
      if (reducido.matches && el.animate) el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, delay: espera || 0, easing: 'ease', fill: 'both' });
      return 0;
    }
    var t = espera || 0;
    g.trazos.forEach(function (tr, i) {
      var d = duracion(tr.L);
      if (tr.guia.animate) {
        tr.guia.animate([{ strokeDashoffset: tr.oculto }, { strokeDashoffset: 0 }], { duration: d, delay: t, easing: CURVA_TRAZO, fill: 'both' });
      } else {
        tr.guia.style.strokeDashoffset = 0;
      }
      t += d + PAUSA;
    });
    return t - PAUSA;
  }

  // Edición de temporada: arma el dibujo completo (o solo su primer trazo) y lanza su entrada
  function temporada(ed) {
    var el = ed.querySelector('.mt-ed__glifo .mt-garabato[data-g]');
    if (!el) return;
    var g = el._mt || construir(el);
    if (!g) return;
    el._dibujado = true;
    var tipo = el.getAttribute('data-g');
    var quieto = reducido.matches || editor || !g.trazos[0].guia.animate;
    // Hoja y copo: completos desde el principio (lo que se ve es su caída). Planta y sol: solo el primer trazo
    var visibles = quieto || tipo === 'hoja' || tipo === 'copo' ? g.trazos.length : 1;
    g.trazos.forEach(function (t, i) { if (i < visibles) t.guia.style.strokeDashoffset = 0; });
    if (quieto) { ed.classList.add('mt-ed--vivo'); return; }
    var caja = ed.querySelector('.mt-ed__glifo'), movil = window.innerWidth < 750, arranque = 600;
    ed.classList.add('mt-ed--vivo');
    var mov = MOVIMIENTOS[tipo](movil);
    if (mov.arranque !== undefined) arranque = mov.arranque;
    caja.animate(mov.cuadros, { duration: mov.dur, delay: arranque, easing: 'linear', fill: 'both' });
    // fill 'forwards' (no 'both'): mientras esperan, los gestos de después no deben tapar la entrada
    if (mov.despues) mov.despues.forEach(function (d) { caja.animate(d.cuadros, { duration: d.dur, delay: arranque + d.desde, easing: d.curva || 'linear', fill: 'forwards' }); });
    // Planta: cuando el tallo ya creció se abren las dos hojitas y luego el botón · Sol: los rayos salen disparados
    var t = arranque + (tipo === 'brote' ? 760 : 620), paso = tipo === 'brote' ? 240 : 65, dur = tipo === 'brote' ? 520 : 300;
    g.trazos.forEach(function (tr, i) {
      if (i < visibles) return;
      tr.guia.animate([{ strokeDashoffset: tr.oculto }, { strokeDashoffset: 0 }], { duration: dur, delay: t, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'both' });
      t += paso;
    });
  }

  /* ---------- Física de los dibujos de temporada ----------
     Cada movimiento se calcula cuadro a cuadro (80–100 posiciones) para que la velocidad nunca se corte:
     nada frena y vuelve a arrancar entre un punto y otro, como pasaría con unos cuantos tramos fijos. */
  function resorte(t, w, z) {   // resorte amortiguado: 0 → 1 (se pasa un poco y se acomoda)
    var wd = w * Math.sqrt(1 - z * z);
    return 1 - Math.exp(-z * w * t) * (Math.cos(wd * t) + (z * w / wd) * Math.sin(wd * t));
  }
  function cuadros(n, fn) { var a = []; for (var i = 0; i <= n; i++) a.push(fn(i / n)); return a; }
  function tr(x, y, r, sx, sy) {
    return 'translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px,0) rotate(' + r.toFixed(2) + 'deg)' +
      (sx !== undefined ? ' scale(' + sx.toFixed(3) + ',' + (sy === undefined ? 1 : sy).toFixed(3) + ')' : '');
  }
  var MOVIMIENTOS = {
    // OTOÑO: la hoja cae desde arriba a la derecha. Desciende con calma, se mece de lado a lado (cada vez menos),
    // se inclina hacia donde se desliza, se "voltea" (se angosta) en cada extremo y se posa suave junto al texto.
    hoja: function (movil) {
      // Más rápida (2026-10-27, pedido del dueño): antes 3.9 s y la gente ya había bajado antes de verla caer
      var DX = movil ? 64 : 96, H = movil ? 84 : 100, A = movil ? 34 : 50, VUELTAS = 1.75;
      return { dur: 2200, arranque: 250, cuadros: cuadros(110, function (s) {
        var p = 0.5 - 0.5 * Math.cos(Math.PI * s);                 // bajada: arranca suave, sostiene, aterriza suave
        var amp = Math.pow(1 - s, 1.15), fase = Math.PI * 2 * VUELTAS * s;
        var x = DX * Math.pow(1 - p, 1.2) + A * Math.sin(fase) * amp;
        var y = -H * (1 - p) - 7 * Math.pow(Math.sin(fase), 2) * amp; // en cada extremo planea y sube un poquito
        var r = 38 * Math.cos(fase) * amp - 20 * (1 - p);           // se inclina según hacia dónde se desliza
        var sx = 1 - 0.55 * Math.pow(Math.sin(fase), 2) * amp;     // se voltea en los extremos
        return { transform: tr(x, y, r, sx), opacity: Math.min(1, s / 0.07) };
      }) };
    },
    // INVIERNO: el copo baja flotando muy despacio, con un vaivén leve, girando cada vez más lento hasta parar; luego destella.
    copo: function (movil) {
      // Más rápido, igual que la hoja (2026-10-27): antes 4.6 s + 0.9 s de destello
      var DX = movil ? 40 : 60, H = movil ? 86 : 104, A = movil ? 22 : 32;
      return { dur: 2400, arranque: 250, cuadros: cuadros(110, function (s) {
        var p = 1 - Math.pow(1 - s, 2.2) * (1 - 0.15 * s);          // baja rápido al principio y aterriza muy lento
        var amp = Math.pow(1 - s, 1.2), fase = Math.PI * 2 * 1.4 * s;
        var x = DX * (1 - p) + A * Math.sin(fase) * amp;
        var y = -H * (1 - p);
        var r = -320 * Math.pow(1 - s, 2.4) + 10 * Math.sin(fase) * amp;
        return { transform: tr(x, y, r, 1), opacity: Math.min(1, s / 0.1) };
      }), despues: [{ desde: 2400, dur: 600, cuadros: cuadros(40, function (s) {
        var k = 1 + 0.26 * Math.sin(Math.PI * s) * (1 - s * 0.4);
        return { transform: tr(0, 0, 0, k, k) };
      }) }] };
    },
    // PRIMAVERA: la plantita crece desde el piso con resorte (se estira de más y se acomoda); después la brisa la mece.
    brote: function () {
      return { dur: 1400, cuadros: cuadros(70, function (s) {
        var k = resorte(s * 1.4, 9, 0.42);
        return { transform: tr(0, 6 * (1 - Math.min(1, k)), 0, 1, Math.max(0, k)), opacity: Math.min(1, s / 0.12) };
      }), despues: [{ desde: 2500, dur: 3000, cuadros: cuadros(80, function (s) {
        return { transform: tr(0, 0, 9 * Math.sin(Math.PI * 2 * 1.5 * s) * Math.pow(1 - s, 1.4), 1, 1) };
      }) }] };
    },
    // VERANO: el sol amanece (sube desde abajo creciendo, con resorte), le salen los rayos y gira despacio hasta detenerse.
    sol: function () {
      return { dur: 1500, cuadros: cuadros(70, function (s) {
        var k = resorte(s * 1.5, 8.5, 0.5);
        return { transform: tr(0, 26 * (1 - k), 0, 0.45 + 0.55 * k, 0.45 + 0.55 * k), opacity: Math.min(1, s / 0.15) };
      }), despues: [{ desde: 1900, dur: 7000, cuadros: cuadros(80, function (s) {
        return { transform: tr(0, 0, 90 * (1 - Math.pow(1 - s, 3)), 1, 1) };
      }) }] };
    }
  };

  // Si cambia el tamaño (girar el celular, cambiar de ventana), se vuelve a calcular. Si ya estaba dibujado, aparece completo.
  function vigilarTamano(el) {
    if (!window.ResizeObserver) return;
    var ro = new ResizeObserver(function () {
      var g = el._mt;
      if (g && Math.abs(el.clientWidth - g.w) < 2 && Math.abs(el.clientHeight - g.h) < 2) return;
      var nuevo = construir(el);
      if (nuevo && el._dibujado) nuevo.trazos.forEach(function (t) { t.guia.style.strokeDashoffset = 0; });
    });
    ro.observe(el);
  }

  /* ---------- notas escritas a mano: se escriben de izquierda a derecha ---------- */
  function escribir(nota, espera) {
    var txt = nota.querySelector('.mt-nota__texto');
    if (!txt) return 0;
    if (reducido.matches || editor || !txt.animate) { txt.style.clipPath = 'none'; return 0; }
    var d = Math.max(450, Math.min(1100, txt.textContent.trim().length * 52));
    txt.animate(
      [{ clipPath: 'inset(-40% 100% -40% -6%)' }, { clipPath: 'inset(-40% -8% -40% -6%)' }],
      { duration: d, delay: espera || 0, easing: CURVA_LETRA, fill: 'both' }
    );
    return d;
  }

  /* ---------- cuándo se dibuja cada cosa ---------- */
  function alAparecer(el, fn) {
    var r = el.closest('.mt-reveal, .mt-reveal-img');
    if (!r || r.classList.contains('mt-visible')) { requestAnimationFrame(function () { fn(r); }); return; }
    var mo = new MutationObserver(function () {
      if (r.classList.contains('mt-visible')) { mo.disconnect(); fn(r); }
    });
    mo.observe(r, { attributes: true, attributeFilter: ['class'] });
  }
  // Para lo que no está dentro de una sección que aparece: espera a que se vea casi completo en pantalla (una sola vez)
  function alVer(el, fn) {
    if (!window.IntersectionObserver) { fn(); return; }
    var io = new IntersectionObserver(function (entradas) {
      if (!entradas[0].isIntersecting) return;
      io.disconnect(); fn();
    }, { threshold: 0.75, rootMargin: '0px 0px -8% 0px' });
    io.observe(el);
  }
  function retrasoDe(r) {
    var d = r ? parseFloat(getComputedStyle(r).getPropertyValue('--mt-delay')) || 0 : 0;
    // un poco después de que la sección termina de aparecer; si su título sube palabra por palabra, al terminar de subir
    return d * 1000 + (r && r.querySelector('.mt-pal') ? 820 : 380);
  }

  function init() {
    // Ficha: "¿no sabes tu talla?" se escribe cuando el cliente llega a las tallas
    document.querySelectorAll('.mt-talla-nota').forEach(function (nota) {
      alVer(nota, function () { escribir(nota, 200); });
    });

    var todos = document.querySelectorAll('.mt-garabato[data-g]');
    if (!todos.length) return;
    document.documentElement.classList.add('mt-garabatos-js');

    // Subrayado gris oscuro de "Escríbenos" en Preguntas frecuentes (el texto viene del editor, aquí se le agrega el garabato)
    document.querySelectorAll('.mt-faq__ayuda--g a').forEach(function (a) {
      if (a.querySelector('.mt-garabato')) return;
      a.classList.add('mt-marca-g');
      var s = document.createElement('span');
      s.className = 'mt-garabato mt-garabato--subrayado mt-garabato--gris';
      s.setAttribute('data-g', 'subrayado'); s.setAttribute('aria-hidden', 'true');
      a.appendChild(s);
    });
    todos = document.querySelectorAll('.mt-garabato[data-g]');

    todos.forEach(function (el) {
      construir(el);
      vigilarTamano(el);
    });

    // Portada: círculo del título (cuando las palabras ya subieron y los tenis aterrizan) → nota → flecha
    document.querySelectorAll('.mt-hero').forEach(function (hero) {
      // ∞ de "Edición permanente": cuando el texto ya se descubrió
      hero.querySelectorAll('.mt-rv__inf .mt-garabato[data-g]').forEach(function (el) { dibujar(el, 760); });
      // Edición de temporada: el dibujo NO se traza; llega moviéndose (mt-wow.css, al ponerle .mt-ed--vivo):
      // hoja y copo caen ya completos · la plantita crece y luego se abren sus hojas y el botón · el sol sale y le salen los rayos
      hero.querySelectorAll('[data-mt-edicion]').forEach(function (ed) { temporada(ed); });
      var t = hero.classList.contains('mt-rv') ? 1000 : 650;
      hero.querySelectorAll('.mt-hero__titulo .mt-garabato[data-g]').forEach(function (el) { t = dibujar(el, t); });
      var nota = hero.querySelector('.mt-hero__nota');
      if (nota) {
        var inicioNota = Math.max(900, t - 250);   // la nota empieza cuando el círculo va cerrando
        t = inicioNota + escribir(nota, inicioNota) + 100;
      }
      hero.querySelectorAll('.mt-hero__fotos > .mt-garabato[data-g], .mt-rv__escena > .mt-garabato[data-g]').forEach(function (el) {
        if (el.offsetParent !== null) dibujar(el, t);
        else el._dibujado = true;   // la versión de la otra pantalla queda lista por si giran el celular
      });
    });

    // Pie: primero se escribe "síguenos", luego la flechita
    document.querySelectorAll('.mt-footer__nota').forEach(function (nota) {
      alAparecer(nota, function () {
        var d = escribir(nota, 250);
        nota.querySelectorAll('.mt-garabato[data-g]').forEach(function (el) { dibujar(el, 250 + d + 80); });
      });
    });

    // Todo lo demás: al entrar en pantalla
    todos.forEach(function (el) {
      if (el.closest('.mt-hero') || el.closest('.mt-footer__nota')) return;
      alAparecer(el, function (r) { dibujar(el, retrasoDe(r)); });
    });
  }

  function arrancar() {
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(init); else init();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  document.addEventListener('shopify:section:load', function () { editor = true; init(); });
})();
